import memoize from 'fast-memoize';
import { idValues, makeIdObject } from 'utils/arrays.js';
import { isEqual, isAfter } from 'utils/date-fns/index.js';

/**
 * Merge subsequent blocks without time inbetween, indicate concurrent blocks
 * @param {*} blocks
 */
function mergeBlocks(set) {
  if (!set) {
    return set;
  }
  let lastBlock;
  const blockList = [];
  idValues(set.blocks).forEach((block) => {
    if (lastBlock && isEqual(lastBlock.end, block.start)) {
      lastBlock.end = block.end;
      lastBlock.timeslots.push(...block.timeslots);
      return;
    }
    let concurrent = 0;
    const isConcurrent = (blk) => blk.concurrent === concurrent && isAfter(blk.end, block.start);
    while (blockList.filter(isConcurrent).length > 0) {
      concurrent++;
    }
    lastBlock = { ...block, concurrent };
    blockList.push(lastBlock);
  });
  return {
    ...set,
    blocks: makeIdObject(blockList),
  };
}

export default memoize(mergeBlocks);
